import { IContext } from "@src/context";
import { vhmwebconfig } from "@src/proto/jsonapi";
import { jsonFetch } from "@src/utils/fetch";
import { isTimeInRange } from "@src/utils/timeInRange";
import { setThankYouPageNotice } from "@src/containers/components/ThankYou/notice";

const API_WEB_CONFIG = "/api/web_config.json";

// TODO: will change to use web config from API
const thankyouPageNotice = {
  enabled: true,
  noticeStartAt: "1734048000000", // 2024-12-13 09:00:00 (JST)
  noticeEndAt: "1736121540000", // 2025-01-06 08:59:00 (JST)
  notice: {
    en: "We will be closed during the New Year holiday period.\r\nNew Year Holiday Closure: Dec. 28, 2024 - Jan. 5, 2025\r\nOur team will respond to any inquiries received during this period, in order, from Jan. 6, 2025 (Mon).",
    ja: "弊社では下記の期間を年末年始休業とさせていただきます。\r\n年末年始休業: 2024年12月28日～2025年1月5日\r\n休業期間中のお問い合わせにつきましては、2025年1月6日（月）より順次対応させていただきます。",
    pt: "Entraremos em Recesso de Final de Ano.\r\nFeriado de Fim de Ano: 28/12/2024 - 05/01/2025\r\nPara consultas durante o período de férias, responderemos sequencialmente a partir de 6 de janeiro de 2025.",
    vi: "Chúng tôi xin thông báo thời gian nghỉ Tết theo như dưới đây.\r\nThời gian nghỉ Tết: 28/12/2024 - 05/01/2025\r\nNhững thắc mắc trong thời gian nghỉ Tết, chúng tôi xin phép giải đáp từ ngày 06/01 theo thứ tự tiếp nhận.",
    zh: "请注意我们将会于以下期间休假\r\n年末年始休假: 2024/12/28 - 2025/1/5\r\n我们会于2025/1/6 早上09:00开始重新营业。\r\n不便之处，敬请原谅。",
    my: "",
    id: "",
    ne: "",
  },
};
const apartmentVisitForm = {
  datePickerDisabledDates: [
    {
      from: "2024/12/26",
      to: "2025/01/05",
    },
  ],
  hideEntranceEnabled: true,
  hideEntranceBtnStartAt: "1735282800000", // 2024-12-27 16:00:00 (JST)
  hideEntranceBtnEndAt: "1736121540000", // 2025-01-06 08:59:00 (JST)
};

export function setupWebConfig(context: IContext) {
  const { locale } = context;

  jsonFetch<vhmwebconfig.IWebConfig>(API_WEB_CONFIG).then((res = {}) => {
    // office hour text
    if (
      res.phoneNumberOfficeHourText &&
      res.phoneNumberOfficeHourText[locale]
    ) {
      setOfficeHourText(res.phoneNumberOfficeHourText[locale]);
    }

    // hide phone number
    if (res.isPhoneNumberInvisible && res.isPhoneNumberInvisible[locale]) {
      hidePhoneNumber();
    }

    // thank you page notice
    setThankYouPageNotice(context, thankyouPageNotice);

    // hide book visit entrance button
    if (
      apartmentVisitForm.hideEntranceEnabled &&
      isTimeInRange(
        apartmentVisitForm.hideEntranceBtnStartAt,
        apartmentVisitForm.hideEntranceBtnEndAt
      )
    ) {
      // disable book visit entrance button
      disableBookVisitEntranceButton(true);
    } else {
      // enable book visit entrance button
      disableBookVisitEntranceButton(false);
      // disable dates in book visit date picker
      saveBookVisitDatePickerDisabledDates(
        apartmentVisitForm.datePickerDisabledDates
      );
    }
  });
}

function setOfficeHourText(text: string) {
  document
    .querySelectorAll("[data-office-hour-text]")
    .forEach((item) => (item.innerHTML = text));
}

function hidePhoneNumber() {
  document
    .querySelectorAll("[data-phone-number-display]")
    .forEach((item) => item.remove());
}

function disableBookVisitEntranceButton(disabled: boolean) {
  document
    .querySelectorAll(
      '[data-popup-id="book-visit"][data-popup-event="popup-open"]'
    )
    .forEach((item) =>
      item.setAttribute(disabled ? "data-disabled" : "data-enabled", "")
    );
}

function saveBookVisitDatePickerDisabledDates(
  dates: { from: string; to: string }[]
) {
  // disabledDates: ["yyyy/mm/dd-yyyy/mm/dd", "yyyy/mm/dd"]
  const disabledDates = dates.map((item) => {
    return `${item.from}-${item.to}`;
  });
  if (disabledDates.length > 0) {
    sessionStorage?.setItem(
      "book_visit_datepicker_disabled_dates",
      JSON.stringify(disabledDates)
    );
  } else {
    sessionStorage?.removeItem("book_visit_datepicker_disabled_dates");
  }
}
